import SearchComponent from '@components/inputs/search/Search.component';
import { Colors } from '@constants/colors.constants';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { useObservable } from '@ngneat/react-rxjs';
import { auditsProposalSuppliersQuery } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.query';
import { auditProposalSuppliersServices } from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.services';
import { OfferFollowUpDetailsRoutes } from '@utils/routes.utils';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import OfferItem from './components/OfferItem';
import ScrollingList from './components/ScrollingList';

const ExpiredOffers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { auditId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [{ auditProposalSuppliers, loading }] = useObservable(auditsProposalSuppliersQuery.auditProposalSuppliers$);

  useEffect(() => {
    if (auditId) {
      auditProposalSuppliersServices.getAuditsProposal(auditId, true).subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options)
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditId]);

  return (
    <Stack p="20px" height={'100%'} spacing={4}>
      <Stack spacing={2} pr={'10px'}>
        <Typography sx={{ color: Colors.black, fontWeight: 700, fontSize: '20px', textAlign: 'left' }}>
          {t('audits.auditOfferFollowUp.expiredOffers.title', { value: auditProposalSuppliers.length })}
        </Typography>
        <SearchComponent
          isCustom
          value={''}
          handleChange={() => undefined}
          bgColor="#F4F6F8"
        />
      </Stack>
      {loading ? (
        <Stack p="20px" height={'100%'} spacing={4} justifyContent={loading ? 'center' : undefined}>
          <CircularProgress size={40} sx={{ alignSelf: 'center' }} />
        </Stack>
      ) : (
        <>
          <ScrollingList height={'100%'} spacing={2}>
            {auditProposalSuppliers
              .sort((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1)
              .map((it) => (
                <OfferItem key={it.id} item={it} isExpired handleClick={() => navigate(`${OfferFollowUpDetailsRoutes.DETAILS_OFFERSTATUS}/${it.id}`)} />
              ))}
          </ScrollingList>
          <Outlet />
        </>
      )}
    </Stack>
  );
};

export default ExpiredOffers;